import * as React from "react";
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { Link } from "react-router-dom";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import CustomSelect from "../CustomComponents/CustomSelect";

export default function PositionsDialog({ handleDialogCallback }) {
    const [refresh, setRefresh] = React.useState(true);
    const [open, setOpen] = React.useState(false);    
    
    const initialValues = {
        name: '',
        shortName: '',
        IsActive: false
    };

    const validFormSchema = Yup.object({
        name: Yup
            .string('Enter a name for the position')
            .required('Position name is required'),
        shortName: Yup
            .string('Enter a short name for this position')
            .required('Short name is required'),
        IsActive: Yup
            .boolean()
    })

    const onTrigger = React.useCallback((values) => {
        const msg = {
            Name: values.name,
            CommonName: values.shortName,
            IsActive: values.IsActive
        };

        handleDialogCallback(msg);        
        handleClose();
    })

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };


    return (
        <div>
            <Button variant="contained" onClick={handleClickOpen}>
                Add Postion
            </Button>
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
                
                <DialogContent>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validFormSchema}
                        onSubmit={(values, { resetForm }) => {
                            onTrigger(values);
                            resetForm();
                        }}
                    >
                        {props => (
                            <Form>
                                <AppBar sx={{ position: 'relative' }}>
                                    <Toolbar>
                                        <IconButton
                                            edge="start"
                                            color="inherit"
                                            onClick={handleClose}
                                            aria-label="close"
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                        <Typography sx={{ ml: 2, flex: 1, color:"white" }} variant="h6" component="div" >
                                            Position
                                        </Typography>
                                       <Button autoFocus color="inherit" onClick={props.handleSubmit}>
                                            save
                                        </Button>
                                    </Toolbar>
                                </AppBar>
                                <DialogTitle>Position Info:</DialogTitle>
                                <div>
                                    <FormControl sx={{ m: 1, width: 220 }}>
                                        
                                        <TextField
                                            name="name"
                                            id="outlined-name"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.name}
                                            error={props.touched.name && Boolean(props.errors.name)}
                                            helperText={props.touched.name && props.errors.name}
                                            label="Name"
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1, width: 220 }}>
                                        
                                        <TextField
                                            name="shortName"
                                            id="outlined-shortName"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.shortName}
                                            error={props.touched.shortName && Boolean(props.errors.shortName)}
                                            helperText={props.touched.shortName && props.errors.shortName}
                                            label="Short Name"
                                        />
                                    </FormControl>
                                </div>
                                <FormControl sx={{ m: 1 }}>
                                    <FormControlLabel
                                        name="IsActive"
                                        label="Active"
                                        control={<Checkbox checked={props.values.IsActive} onChange={props.handleChange} />}
                                    />
                                </FormControl>
                            </Form>
                        )}
                    </Formik>
                </DialogContent>                
            </Dialog>
        </div>
    );
}